import AssignPermissions from "../components/AssignPermission";
import BillingSummaryLayer from "../components/BillingSummarylayer";
import Breadcrumb from "../components/Breadcrumb";

const AssignPermissionsPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Billing Summary" />

      <BillingSummaryLayer />
    </>
  );
};

export default AssignPermissionsPage;
